/**
 * # EXPERIMENTAL
 *
 * **This plugin is experimental and may change or be removed.**
 */
export const createTransition = (transition) => transition;
